import { AudioPodClient } from '../client/AudioPodClient';
import { CreditInfo, CreditUsageRecord } from '../types';

export class CreditService {
  constructor(private client: AudioPodClient) {}

  async getCreditBalance(): Promise<CreditInfo> {
    const response = await this.client.get<any>('/credits');
    return {
      balance: response.balance,
      paygBalance: response.payg_balance,
      totalAvailableCredits: response.total_available_credits,
      nextResetDate: response.next_reset_date,
      totalCreditsUsed: response.total_credits_used
    };
  }

  async getUsageHistory(): Promise<CreditUsageRecord[]> {
    return this.client.get<CreditUsageRecord[]>('/credits/usage');
  }

  async getCreditMultipliers(): Promise<Record<string, number>> {
    return this.client.get<Record<string, number>>('/credits/multipliers');
  }
}
